export enum KeyValue {
    ArrowDown = 'ArrowDown',
    ArrowLeft = 'ArrowLeft',
    ArrowRight = 'ArrowRight',
    ArrowUp = 'ArrowUp',
    Backspace = 'Backspace',
    Control = 'Control',
    Delete = 'Delete',
    End = 'End',
    Enter = 'Enter',
    Escape = 'Escape',
    Home = 'Home',
    Meta = 'Meta',
    PageDown = 'PageDown',
    PageUp = 'PageUp',
    Spacebar = 'Space',
    Tab = 'Tab',
    Unidentified = 'Unidentified',
}
